<!--Header-->
<template>
  <v-app-bar app absolute color="white" elevation="1">
    <v-app-bar-nav-icon @click.stop="drawerStatusChange()"></v-app-bar-nav-icon>

    <v-container fluid class="py-0 px-8">
      <v-row>
        <v-col cols="1" class="mt-1">

        </v-col>
        <v-col cols="1"> </v-col>
        <v-col cols="8" class="mt-1">
          <div
            class="
              text-h6
              grey--text
              font-weight-normal
              text--darken-1 text-center
            "
          >
            {{ this.$store.getters.getHeaderTitle }}
          </div>
        </v-col>
        <v-spacer />
        <v-col cols="2"> </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  props: ["drawerStatus"],
  data() {
    return {
      items: [
        { name: "Ingredient List", route: "/ingredientList" },
        { name: "Suppliers", route: "/supplierList" },
      ],
    };
  },
  methods: {
    drawerStatusChange() {
      this.$emit("drawerStatus", !this.drawerStatus);
    },
    logout() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
